'use strict';

var React = require('react');

const IntlContext = /*#__PURE__*/React.createContext(undefined);

exports.IntlContext = IntlContext;
